import { APP_STORE_URL } from '../constants/links';

const DownloadPage = () => {
  window.location.replace(APP_STORE_URL);
  return null;
};

export default DownloadPage;
